import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';

const ProductListWithImage = ({ productList }) => {
	return (
		<List dense={true}>
			{productList.map(product => {
				return (
					<ListItem key={product._id}>
						<ListItemAvatar>
							<Avatar>
								<img
									src={product?.image?.url}
									alt={'product'}
									width='100%'
									height='100%'
								/>
							</Avatar>
						</ListItemAvatar>
						<ListItemText
							primary={product.subProductName}
							secondary={`单价$${product.unitPrice}`}
						/>
						<ListItemSecondaryAction>
							x{product.quantity}
						</ListItemSecondaryAction>
					</ListItem>
				);
			})}
		</List>
	);
};

ProductListWithImage.propTypes = {
	productList: PropTypes.array.isRequired,
};

export default ProductListWithImage;
